import firebase from 'firebase/app';

import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

var firebaseConfig = {
  apiKey: 'AIzaSyDe5rwuI1SVNXAqI71Im5F0yv53CjnDk6A',
  authDomain: 'progaming-cybersecurity.firebaseapp.com',
  databaseURL: 'https://progaming-cybersecurity.firebaseio.com',
  projectId: 'progaming-cybersecurity',
  storageBucket: 'progaming-cybersecurity.appspot.com',
  messagingSenderId: '95443929803',
  appId: '1:95443929803:web:a68c80cfed96bdc0b9294e',
  measurementId: 'G-9KEV04MKR9',
};

firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const database = firebase.firestore();
const storage = firebase.storage();
const functions = firebase.functions();
const fieldValue = firebase.firestore.FieldValue;
const analytics = firebase.analytics();
const api =
  'https://asia-northeast1-progaming-cybersecurity.cloudfunctions.net';
// const api = 'http://localhost:5000/progaming-cybersecurity/asia-northeast1';

// uncomment the line below for local development
// functions.useEmulator('localhost', 5001);

export { analytics, api, auth, database, fieldValue, functions, storage };
